import { httpsCallable } from "firebase/functions"
import { fbFunctions } from "../../firebase"

export type FeatureFlagName =
  | "adminPanel"
  | "pinnedCards"
  | "byokEncryption"
  | "avatarGear"
  | "launchV1"
  | "paymentsLive"

export type FeatureFlags = Partial<Record<FeatureFlagName, boolean>>

export const BOARD_LEVEL_FLAGS: ReadonlySet<FeatureFlagName> = new Set([
  "pinnedCards",
  "byokEncryption",
])

export const ALL_FEATURE_FLAGS: FeatureFlagName[] = [
  "adminPanel",
  "pinnedCards",
  "byokEncryption",
  "avatarGear",
  "launchV1",
  "paymentsLive",
]

export async function fetchFeatureFlags(): Promise<FeatureFlags> {
  const fn = httpsCallable<void, { flags: FeatureFlags }>(fbFunctions, "getEntitlements")
  const result = await fn()
  return result.data.flags
}
